import axios from 'axios';
import { signInPath } from './authNavigation';

// Default to this deployment, not a preview URL baked into the build.
// A separately hosted API must be configured deliberately and allow credentials.
const API_BASE = `${(process.env.REACT_APP_API_ORIGIN || '').replace(/\/$/, '')}/api`;

export const clearAuthToken = () => {
  try { localStorage.removeItem('token'); } catch { /* Storage may be disabled. */ }
};

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 15000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && !error.config?.url?.startsWith('/auth/')) {
      clearAuthToken();
      window.location.href = signInPath(window.location.pathname + window.location.search);
    }
    return Promise.reject(error);
  }
);

export default api;
